export default "__VITE_ASSET__QrTaVudX__"